import React from 'react';
import { connect } from "react-redux";
import { Container, Row, Col } from 'react-bootstrap'
import Alert from '../common/modal/Alert';
import Loading from '../common/modal/Loading';
import FormTemplate from "../common/form/FormTemplate";
import LoginTop from "../top/LoginTop";
import axios from "axios";
import configData from "../../config/config.json";
import Footer from '../bottom/Footer'
import { LOADING_STATUES } from "../constants/constants";
import translations from "../../config/translation/login_translations.json"

const mapStateToProps = state => {
	return {
		language: state.languageReducer ? state.languageReducer : 'ENGLISH'
	};
}

class ForgotUsernameBig extends React.Component {
	state = {
		email: "",
		showAlert: false,
		alertMessage: "",
		loadingStatus: "",
		errors: {},
		redirectToLogin: false
	  }

	showLoading = () => {
		if (this.state.loadingStatus === "") {
			this.setState({
				loadingStatus: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	handleChange = (event) => {
		event.preventDefault();
	
		let value = event.target.value;
		this.setState({
		   [event.target.id]: value,
		   errors: {}
		})
	}

	handleSubmit = (event) => {
		event.preventDefault();

		if (this.showLoading() === true) {
			let { showAlert, alertMessage, loadingStatus, errors, redirectToLogin, ...request } = this.state; // remove UI only fields before submitting
			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "auth/forgotUsername", request, { withCredentials: true })
				.then((response) => {
					this.setState({loadingStatus: "", redirectToLogin: true}, this.showAlert(response.data.message)); 
				}, (error) => {
					this.setState({ loadingStatus: "", redirectToLogin: false }, this.showAlert(error.response.data.message));
				});
		}
	}
	
	handleCancel = (event) => {
		event.preventDefault();
		this.props.history.push('/login');
	}

	showAlert = (alertMessage) => {
		this.setState({
		  showAlert: true,
		  alertMessage
		})
	  }
	
	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertMessage: ""
		})
		if (this.state.redirectToLogin) {
			this.props.history.push('/login');
		}
	}

	render() {
		let formGroupRows = [
			{
				formGroups: [ { id: 'email', label: translations[this.props.language].email, fieldType: 'email', labelFor: 'email', value: this.state.email, style: {minWidth: 250},  required: true, primaryCriteria: true,  error: this.state.errors['email']  }]
		  	}

		]

		const formProps = {
			componentName: "ForgotUsername",
			pageHeading: translations[this.props.language].forgot_username_question,
			onChange: this.handleChange,
			onSubmit: this.handleSubmit,
			onCancel: this.handleCancel,
			primaryButtonLabel: translations[this.props.language].send_email,
			formGroupRows: formGroupRows,
			formOnly: true
		}

		return (
			<>
                <LoginTop />
				<section className="cn container-fluid" style={{background: '#145A7B' }}>
				<div style={{background: 'white'}}>
					<Container fluid="true" >
						<Row>
						<Col>
							<FormTemplate {...formProps} />
						</Col>
						</Row>
					</Container>
				</div>
				</section>
				<Footer />
				<Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
				<Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} />
			</>
        )
    }
}

export default connect(mapStateToProps)(ForgotUsernameBig);
